import has from '@dojo/framework/core/has';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { userstate, createNlsMiddleware } from '@holmescorp/lcc-state';
import { PrePostViz } from '@holmescorp/prepost-viz';
import { quizstate } from '../support/state';
import css from '../css/module-results.m.css';
const nls = createNlsMiddleware('quiz');
const factory = create({ theme, nls, quizstate, userstate }).properties();
const isEmpty = (obj) => Object.keys(obj).length === 0;
export const ModuleProgress = factory(({ properties, middleware: { theme, quizstate, userstate } }) => {
    const { quizstore } = properties();
    quizstate.setStore(quizstore);
    const quiz = quizstate.get(quizstate.path('quiz'));
    const quizkind = quiz && quiz.kind;
    const { get, path } = userstate;
    let modules = undefined;
    let label = '';
    let useCutscores = false;
    let whichtest = 'posttest';
    switch (quizkind) {
        case 'pretest':
            break;
        case 'posttest':
            {
                const posttest = get(path('posttest'));
                if (posttest) {
                    modules = posttest.tree;
                    label = quiz ? quiz.title : 'Post-Test';
                    whichtest = 'posttest';
                }
            }
            break;
        case 'practice':
            {
                const practice = get(path('practice'));
                if (practice) {
                    modules = practice;
                    label = quiz ? quiz.title : 'Post-Test';
                    useCutscores = has('use-cutscores') ? true : false;
                    whichtest = 'practice';
                }
            }
            break;
    }
    const status = get(path('status'));
    if (modules === undefined || !status) {
        return null;
    }
    const instancekey = quizstate.get(quizstate.path('instancekey'));
    const themeCss = theme.classes(css);
    const cutscores = () => {
        const info = quizstate.get(quizstate.path('info'));
        const quizPattern = get(path('quizPattern'));
        const lastresult = info && info.lastresult;
        if (!lastresult || isEmpty(lastresult)) {
            return null;
        }
        return v('section', { key: `modules-${instancekey}`, classes: [themeCss.cutscoreBlock] }, [
            w('CutScores', { key: `cutscores-${instancekey}`, label, modules, quizPattern })
        ]);
    };
    if (useCutscores) {
        return cutscores();
    }
    return v('div', { key: `modules-${instancekey}`, classes: [themeCss.root] }, [w(PrePostViz, { whichtest })]);
});
